import { t } from '@lingui/macro';
import { WorkPackageAdminTab, WorkPackageAdminTabType } from './types';

export const workPackageAdminTabList: WorkPackageAdminTab[] = [
  { label: t`Work Package Disciplines`, value: WorkPackageAdminTabType.DISCIPLINES },
  { label: t`Work Package Card Design`, value: WorkPackageAdminTabType.CARD },
  { label: t`Initial Work Package Import`, value: WorkPackageAdminTabType.IMPORT },
];
